import React from "react";
import "./Green_btn.css";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { postCart } from "../../../../features/cart/cartSlice";

function Replace_btn({
  btnText,
  onClick,
  addtext,
  product,
  quantity,
  selectedVariant,
  disabled,
}) {
  return (
    <>
      <section className="Green_btn_holder">
        <Button className="Green_btn" disabled={disabled} onClick={onClick}>
          <span>{addtext}</span>
          {btnText}
        </Button>
      </section>
    </>
  );
}

export default Replace_btn;
